import { Box } from '@mui/material';
import { AiOutlineLogout, AiOutlineHistory } from 'react-icons/ai';
import { BsClipboardCheck } from 'react-icons/bs';
import { CgProfile } from 'react-icons/cg';
import { HiOutlineInformationCircle } from 'react-icons/hi';
import { MdOutlineMapsHomeWork, MdSecurity, MdOutlineHelpOutline } from 'react-icons/md';
import { RiLockPasswordLine, RiSettingsLine } from 'react-icons/ri';
import { Item, WsColors } from 'wisestep-base';

import SettingsIndex from '../../../../components/SettingsIndex';
import { logout } from '../../../../utils/token';

const UserProfileIndex = () => {
  return (
    <Box p={3}>
      <Item sx={{ backgroundColor: WsColors.White }}>
        <SettingsIndex
          options={[
            {
              label: 'Profile',
              icon: <CgProfile size={25} />,
              url: '/recruiter/profile',
              subOptions: [
                {
                  label: 'Personal Info',
                  icon: <HiOutlineInformationCircle size={22} />,
                  url: '/recruiter/profile',
                },
                {
                  label: 'Workspace Info',
                  icon: <MdOutlineMapsHomeWork size={22} />,
                  url: '/recruiter/workspace',
                },
                {
                  label: 'Onboarding Info',
                  icon: <BsClipboardCheck size={23} />,
                  url: '/recruiter/onboarding',
                },
              ],
            },
            {
              label: 'Security',
              icon: <MdSecurity size={25} />,
              url: '/recruiter/password',
              subOptions: [
                {
                  label: 'Password',
                  icon: <RiLockPasswordLine size={24} />,
                  url: '/recruiter/password',
                },
              ],
            },
            {
              label: 'My Activity',
              icon: <AiOutlineHistory size={24} />,
              url: '/recruiter/activity',
            },
            {
              label: 'App Settings',
              icon: <RiSettingsLine size={25} />,
              url: '/app-settings',
            },
            {
              label: 'FAQs',
              icon: <MdOutlineHelpOutline size={25} />,
              url: '/recruiter/faq',
            },
            { label: 'Logout', icon: <AiOutlineLogout size={25} onClick={() => logout()} /> },
          ]}
        />
      </Item>
    </Box>
  );
};
export default UserProfileIndex;
